/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-children-prop */
import React, { useState, useEffect } from 'react'
import { Input, InputLeftElement, InputGroup } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export default function SearchGraph({ data, setData }) {
  const { t } = useTranslation()
  //console.log('data', data)
  const [searchWord, setSearchWord] = useState('')

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const res = data?.filter((graph) =>
        graph?.chartLabel?.includes(searchWord)
      )
      setData(res)
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [searchWord])

  const handleSearch = (word) => {
    // console.log(data)
    setSearchWord(word)
  }
  return (
    <div>
      <InputGroup>
        <InputLeftElement
          pointerEvents="none"
          children={<i className="fa fa-search" aria-hidden="true"></i>}
        />
        <Input
          className="shadow-md"
          colorScheme="black"
          placeholder={t('utility.search')}
          onChange={(e) => {
            data && handleSearch(e.target.value)
          }}
        />
      </InputGroup>
    </div>
  )
}
